import { Component, OnInit, Inject } from '@angular/core';
import { BeneficiariosService } from '../../services/beneficiarios.service';
import { BeneficiarioAp } from '../../entities/beneficiario-ap';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Eps } from 'app/entities/eps';
import { Observable } from 'rxjs';
import { ServiciosService } from 'app/services/servicios.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-usuarios-ap',
  templateUrl: './usuarios-ap.component.html',
  styleUrls: ['./usuarios-ap.component.scss']
})
export class UsuariosApComponent implements OnInit {
  public beneficiarios:Array<BeneficiarioAp>;
  public beneficiario:BeneficiarioAp;
  public eps$:Array<Eps>;
  constructor(
              private _beneficiarios:BeneficiariosService,
              @Inject(MAT_DIALOG_DATA) public data,
              private _service:ServiciosService,
              private dialogs:MatDialog) {
    this.beneficiario = new BeneficiarioAp();
    this._beneficiarios.usuariosDeUnBeneficiario(this.data.matricula).subscribe(beneficiarios=>{
        this.beneficiarios = beneficiarios;
    });
    this._service.getAllEps().subscribe(succ=>{
      this.eps$ =succ;
    });
  }

  ngOnInit() {
  }

  updateAP(beneficiario:BeneficiarioAp){
    this._beneficiarios.updateAp(beneficiario)
        .subscribe((succ:any)=>{
          if(succ.affectedRows > 0){
            swal.fire({
              type:'success',
              text:'Se actualizó correctamente el beneficiario',
              showConfirmButton:false,
              timer:1200,
              title:'Exito!'
            })
          }
        })

  }
  nuevoAp(){
    this.beneficiario.matricula = this.data.matricula;
    this._beneficiarios.nuevoApBySocket(this.beneficiario);
    this.dialogs.closeAll();
  }

  crearAP(beneficiario:BeneficiarioAp){
    this.beneficiario.matricula = this.data.matricula;
    this._beneficiarios.nuevoServicioBySocket(beneficiario);
    this.dialogs.closeAll();
  }
}
